// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__hM2zx","body":"style__body__Z3zFD","header":"style__header__TLo6g","footer":"style__footer__fKu5+","footerContent":"style__footerContent__gEpYJ"};